// hooks
import { useCallback, useEffect, useState, Fragment } from "react";
import useHttp from "hooks/use-http";

// material styles
import { Grid, IconButton, Tooltip } from "@mui/material";

// material icons
import { Edit } from "@mui/icons-material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import PaginationCM from "components/shared/Pagination";

// helper
import GenerateHeadCell from "helper/generate-head-cell";

// constants
import { PAGINATION_LIMIT } from "constants";

import { useNavigate } from "react-router-dom";
import { getWorkSamplesDataRequest } from "api/requests/work_sample";

// products head cells
const headCells = GenerateHeadCell("work_samples_list");

function DisplayWorkSamples() {
  const { request, loading, setLoading } = useHttp(false);

  const navigate = useNavigate();

  // states for filtered
  const [searchValue, setSearchValue] = useState("");

  // workSampls data state
  const [workSamplesData, setWorkSamplesData] = useState({
    data: [],
    count: 0,
  });

  // page state for pagination
  const [page, setPage] = useState(1);

  const handleSearch = (e) => setSearchValue(e);

  // get all workSamples data
  const getWorkSamplesData = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getWorkSamplesDataRequest,
      values: {
        skip: searchValue ? 0 : (page - 1) * PAGINATION_LIMIT,
        limit: searchValue ? 100 : PAGINATION_LIMIT,
        search: searchValue || null,
      },
      isMulty: true,
    });
    setLoading(false);
    if (res) {
      if (res.data.count < 1) {
        return setWorkSamplesData({
          count: res.data.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }
      let transformedData = res.data.data.map((items) => ({
        id: items.id,
        title: items.title,
        edit: (
          <IconButton
            sx={{ color: "#1B569A" }}
            onClick={() => {
              navigate("/work_samples/edit/" + items.id);
            }}
          >
            <Tooltip title="ویرایش" placement="top">
              <Edit />
            </Tooltip>
          </IconButton>
        ),
      }));
      setWorkSamplesData({
        data: transformedData,
        count: res.data.count,
      });
    }
    setLoading(false);
  }, [page, searchValue]);

  useEffect(() => {
    getWorkSamplesData();
  }, [getWorkSamplesData]);
  return (
    <DrawerCM title="نمونه کارها" onSearch={handleSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست نمونه کار"
                rows={workSamplesData.data}
                headCells={headCells}
                page={page}
                addWorkSample
                colspan={workSamplesData.count === 0 ? "11" : ""}
                fontSize="12px"
                cellFontSize="12px"
              />
            </Grid>
            {workSamplesData.count < 1 ? (
              ""
            ) : (
              <PaginationCM
                handleChange={(_, val) => setPage(val)}
                page={page}
                count={workSamplesData.count}
              />
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}

export default DisplayWorkSamples;
